import {createAction, props} from '@ngrx/store';
import {IEnvironmentState} from '@spout/web-global/models';

export const loadEnvironment = createAction('[Environment] Load Environment', props<{payload: IEnvironmentState}>());
